import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LockIconComponent } from '../../../@icons/lock-icon.component';
import { PosthogService } from '../../@services/front/posthog.service';

/**
 * Encart d'appel au premium, réutilisable partout.
 *
 * Principe : on ne vend jamais dans le vide. Cet encart se place là où la
 * valeur vient d'être DÉMONTRÉE (sous les conseils du jour, sur la fiche d'une
 * plante que l'utilisateur consulte), jamais en interstitiel.
 *
 * Il n'emprunte jamais le canal des notifications : une sollicitation
 * commerciale déguisée en conseil de jardinage est une ligne rouge du projet.
 *
 * Il se place là où une fonction premium est effectivement DÉBLOCABLE, et dit
 * laquelle. Un encart générique au milieu d'un écran sans rapport ne convertit
 * pas : il agace.
 *
 * Usage : `<vw-premium-teaser [message]="'premium.teaser.gdd' | translate"
 *            [detail]="'premium.teaser.gdd-detail' | translate"
 *            source="plant_details" (ctaClicked)="openPaywall()" />`
 */
@Component({
  selector: 'vw-premium-teaser',
  standalone: true,
  imports: [CommonModule, TranslateModule, LockIconComponent],
  templateUrl: './premium-teaser.component.html',
})
export class PremiumTeaserComponent {
  /** Ce que Premium débloque ICI, déjà traduit. */
  @Input() message = '';
  /**
   * Précision concrète sous le titre, déjà traduite.
   *
   * Sans elle, l'encart retombe sur « Découvrir Premium » : correct, mais
   * l'utilisateur doit cliquer pour savoir ce qu'il y gagne. Avec elle, il
   * décide en connaissance de cause — et on ne lui fait pas ouvrir un écran
   * pour rien.
   */
  @Input() detail = '';
  /** Libellé du bouton (clé i18n par défaut). */
  @Input() ctaLabel = 'premium.teaser.cta';
  /** Emplacement, pour mesurer quel encart convertit. */
  @Input() source = 'unknown';
  /** Variante compacte, pour s'insérer dans une liste. */
  @Input() compact = false;

  @Output() ctaClicked = new EventEmitter<string>();

  private readonly posthog = inject(PosthogService);

  onClick(): void {
    this.posthog.capture('teaser_clicked', { placement: this.source });
    this.ctaClicked.emit(this.source);
  }
}
